import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { connect, useDispatch, useSelector } from 'react-redux';
import { modalState, toggleModal, detailOpenState } from 'reducers/ui';
import LayoutWithMap from 'containers/Base/LayoutWithMap';
import { getUserAssignedDepartmentList } from 'reducers/users';
import useFilters from 'containers/Base/useFilters.js';
import { filters } from 'containers/Pages/Tasks/PatrolTemplates/filters';
import { getSecurityCompanyServices } from 'reducers/securityCompany';
import useSites from 'containers/Pages/Locations/Sites/Layouts/useSite';

import { nameSpace } from '../Modules/nameSpace';
import { actions as patrolTemplateActions } from 'containers/Pages/Tasks/PatrolTemplates/Modules/dataGridTable';
import { actions as patrolTemplateFilterActions } from 'containers/Pages/Tasks/PatrolTemplates/Modules/filters';
import * as patrolTemplateSelectors from 'containers/Pages/Tasks/PatrolTemplates/Selectors/patrolTemplateSelectors';
import useBusinessClients from 'containers/Pages/People/BusinessClients/Layouts/useBusinessClient';
import { PAGE_URLS } from 'utils/constants';

const PatrolTemplate = ({
  columns,
  filtersRequired,
  FormComponent,
  editable,
  details,
  loading,
}) => {
  //---------------------------Selectors---------------------------
  const detailOpen = useSelector(state => detailOpenState(state));

  const patrolTemplateListData = useSelector(state =>
    patrolTemplateSelectors.getPatrolTemplateListTransformed(state),
  );
  const totalEntries = useSelector(state =>
    patrolTemplateSelectors.getTotalEntries(state),
  );
  const filterValues = useSelector(state =>
    patrolTemplateSelectors.getPatrolTemplateFilters(state),
  );
  const forceRefresh = useSelector(state =>
    patrolTemplateSelectors.getForceRefresh(state),
  );
  const modalOpen = useSelector(state => modalState(state));

  const userAssignedDepartments = useSelector(state =>
    getUserAssignedDepartmentList(state),
  );
  //--------------------------customHooks--------------------------
  const { localFilterValues, updateFilter } = useFilters({
    filterValues,
  });
  const bizClients = useBusinessClients();
  const sites = useSites();
  /**
   * TODO capture the selected business client
   */
  //---------------------------Actions------------------------------
  const dispatch = useDispatch();
  const dispatchFetchPatrolTemplateList = useCallback(
    ({ filters, from }) =>
      dispatch(patrolTemplateActions.fetchGridList({ filters, from })),
    [dispatch],
  );

  const dispatchToggleModal = useCallback(
    () => dispatch(toggleModal(nameSpace)),
    [dispatch],
  );
  const dispatchFetchPatrolQr = useCallback(
    id => dispatch(patrolTemplateActions.fetchQr({ id })),
    [dispatch],
  );
  //----------------------------------------------------------------
  const onUpdate = filters => {
    dispatchFetchPatrolTemplateList({
      filters,
    });
  };
  const fetchPatrolTemplates = from => {
    dispatchFetchPatrolTemplateList({
      filters: localFilterValues,
      from,
    });
  };
  const PatrolTemplateFormComponent = useCallback(
    props => (
      <FormComponent
        {...props}
        userAssignedDepartments={userAssignedDepartments}
      />
    ),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [userAssignedDepartments],
  );

  const getListData = patrolsDef => {
    return patrolsDef.map(p => {
      p.btnData = { id: p.id, onClick: dispatchFetchPatrolQr };
      return p;
    });
  };

  return (
    <LayoutWithMap
      header="Patrol Templates"
      cols={columns}
      data={getListData(patrolTemplateListData)}
      totalEntries={totalEntries}
      loading={loading}
      forceRefresh={forceRefresh}
      //details
      DetailComponent={details}
      //creating and editing
      editable={editable}
      FormComponent={PatrolTemplateFormComponent}
      toggleModal={dispatchToggleModal}
      onEdit={modalOpen[nameSpace]}
      //filters
      filtersRequired={filtersRequired}
      filterValues={localFilterValues}
      filters={filters({
        bizClients,
        sites,
        businessClient: localFilterValues.businessClient,
        userAssignedDepartments,
      })}
      setFilters={(values, hasApplyFilter) =>
        updateFilter({
          values,
          hasApplyFilter,
          applyFilter: filters => {
            patrolTemplateFilterActions.setFilterKey({ key: true });
            patrolTemplateFilterActions.setFilters({ filters });
          },
        })
      }
      //end-filters
      onUpdate={onUpdate}
      fetchData={fetchPatrolTemplates}
      //setGridAPI={gridAPIHandler}
      persistentStateName={PAGE_URLS.TEMPLATE_PATROLS.name}
      forceOpenDetailPanel={detailOpen[PAGE_URLS.TEMPLATE_PATROLS.link]}
    />
  );
};

PatrolTemplate.propTypes = {
  columns: PropTypes.array.isRequired,
  details: PropTypes.func.isRequired,
  editable: PropTypes.bool.isRequired,
  filtersRequired: PropTypes.bool.isRequired,
  loading: PropTypes.bool,
  FormComponent: PropTypes.elementType,
  userAssignedDepartments: PropTypes.array,
  services: PropTypes.array,
};
const mapStateToProps = state => ({
  services: getSecurityCompanyServices(state),
});

export default connect(mapStateToProps)(PatrolTemplate);
